import { OGProperties, PageTags } from '../types';
import { RoutesPaths } from '@router/constants';

const title = 'Account Lockup (NEW)'
const url = window.location.origin + RoutesPaths.ACCOUNT.LOCKING_MULTIPERIOD

export const accountLockupNew: PageTags = {
  title: `| ${title}`,
  url: url,
  properties: [
    {
      property: OGProperties.title,
      content: `FireStarter | ${title}`,
    },
    {
      property: OGProperties.description,
      content: 'Lock your $FLAME. Determine your Tier. Receive Allocations from FireStarter Projects',
    },
    {
      property: OGProperties.url,
      content: url,
    },
  ]
}
